const vows = [
  "Continuar te escolhendo, nos dias fáceis e nos difíceis",
  "Nunca tratar como rotina o privilégio de ter você ao meu lado",
  "Ser honesto, especialmente quando for difícil",
  "Caminhar do seu lado, te apoiar e te dar a mão para enfrentar o que vier",
  "Construir uma vida da qual a gente possa se orgulhar",
  "E que, não importa quantos anos passem, você nunca vai duvidar do meu amor",
];

function Vows() {
  return (
    <div
      id="vows"
      className="d-flex align-items-center justify-content-center py-5"
    >
      <div className="container py-5">
        <h1>Renovação dos votos</h1>
        <br />
        <h3 className="mb-5">Eu prometo...</h3>
        {vows.map((vow, i) => (
          <div key={i}>
            <h3>{vow}</h3>
            <br />
          </div>
        ))}
        <h3>Para sempre seu,</h3>
        <h3>Gabriel</h3>
      </div>
    </div>
  );
}

export default Vows;
